export default "__VITE_ASSET__D5Zw5lSv__"